export default [
  {
    altText: "Hotel Banner",
    bannerID: "banner-1",
    desktopImage:
      "https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/blte19cd45bc72c6416/600fe87f0839e910126d71ab/DELIVERS_GENERIC_WEB-HERO-BANNER.jpg",
    mobileImage:
      "https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/bltb51a3924fe651ce8/600fe8e4533a1810075f64c8/DELIVERS_GENERIC_MOBILE-HERO-BANNER.jpg",
    tabletImage:
      "https://images.contentstack.io/v3/assets/blt3b916845fcb268b5/blte605652a731f9f7d/5ffffc0649cfff488f0f75a4/seo-unlimited-free-delivery-banner.jpg",
    redirectUrl:
      "http://airasia.com/food" +
      "?utm_medium=internal&utm_source=aa_herobanner&utm_campaign=ec_my_aw|aadelivers-gored-unlimiteddelivery|27012021|my-en&utm_content=food",
  },
]
